/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';
import CountUp from 'components/CountUp';
import { Fade } from 'react-awesome-reveal';

const defaultStats = [
  {
    id: 's1',
    value: 160,
    label: 'Happy Clients',
    suffix: '+',
  },
  {
    id: 's2',
    value: 100,
    label: '5-Star Reviews',
    suffix: '+',
  },
  {
    id: 's3',
    value: 4380,
    label: 'Cups of Coffee',
    suffix: '+',
  },
  {
    id: 's4',
    value: 6712,
    label: 'Virtual High-Fives',
    suffix: '+',
  },
  {
    id: 's5',
    value: 100,
    label: 'Awesomeness',
    suffix: '%',
  },
  {
    id: 's6',
    value: 1000,
    label: 'Client Business Reviews',
    suffix: '+',
  },
  {
    id: 's7',
    value: 4500,
    label: 'Devices Protected',
    suffix: '+',
  },
  {
    id: 's8',
    value: 1000001,
    label: 'Threats Prevented',
    suffix: '+',
  },
];

export default function StatsGrid({ list }) {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative top accent */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-green-400 to-transparent opacity-30" />

      <div className="container mx-auto px-6">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4">
              By The Numbers
            </span>
            <h2 className="text-3xl lg:text-5xl font-extrabold text-surface-900 tracking-tight">
              IT Support &amp; Solutions That a Growing Business Needs.
            </h2>
            <p className="text-surface-300 mt-4 text-lg max-w-2xl mx-auto">
              We can work with your internal teams or run everything for you.
            </p>
          </div>
        </Fade>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-8">
          {list.map((s, i) => (
            <Fade key={s.id} direction="up" delay={i * 100} triggerOnce>
              <div className="glass-card-static text-center p-6 hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1">
                <CountUp
                  end={s.value}
                  duration={1800}
                  separator=","
                  suffix={s.suffix || ''}
                  className="text-3xl sm:text-4xl md:text-4xl font-extrabold gradient-text"
                />
                <div className="mt-2 text-sm text-surface-300 font-medium uppercase tracking-wider">{s.label}</div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
}

StatsGrid.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.number,
      label: PropTypes.string,
      suffix: PropTypes.string,
    }),
  ),
};

StatsGrid.defaultProps = {
  list: defaultStats,
};
